import AutogestionLogList from './AutogestionLogList'
export {AutogestionLogList}
export default AutogestionLogList
